App.filter('isOver70FromBirthdate', function () {
    return function (date) {
        date = date || '';
        if (date) {
            	var date = new Date(date);
        	var preciseMiliseconds = new Date(date.getFullYear() + 70, date.getMonth(), date.getDate()).getTime();
        	var nowMiliseconds = new Date().getTime();

        	console.log(preciseMiliseconds, nowMiliseconds, preciseMiliseconds > nowMiliseconds, new Date(date.getFullYear() + 69, date.getMonth(), date.getDate()));

        	return preciseMiliseconds < nowMiliseconds;
        } else {
        	return false;
        }
    };
});
